import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getPopularSelections } from "@/api/selections";

enum SelectionsQueryKeys {
  Popular = "selections.popular",
}

export const usePopularSelections = () => {
  const locale = useLocale();

  return useQuery({
    queryKey: [SelectionsQueryKeys.Popular, locale],
    queryFn: ({ signal }) => {
      const params = { lang: locale };
      return getPopularSelections({ params, signal });
    },
  });
};
